import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Index";
import Configurator from "@/components/Configurator";
import PatternUpload from "@/components/PatternUpload";
import CreateOrgProject from "@/components/org-onboarding/CreateOrgProject";
import SelectOrgStyles from "@/components/org-onboarding/SelectOrgStyles";
import UploadOrgLogo from "@/components/org-onboarding/UploadOrgLogo";
import SelectOrgColors from "@/components/org-onboarding/SelectOrgColors";
import OrgConfirm from "@/components/org-onboarding/OrgConfirm";
import OrgSubmitted from "@/components/org-onboarding/OrgSubmitted";

import CreateDistProject from "@/components/distributor-onboarding/CreateDistProject";
import SelectDistStyles from "@/components/distributor-onboarding/SelectDistStyles";
import UploadDistLogo from "@/components/distributor-onboarding/UploadDistLogo";
import SelectDistColors from "@/components/distributor-onboarding/SelectDistColors";
import DistConfirm from "@/components/distributor-onboarding/DistConfirm";
import DistSubmitted from "@/components/distributor-onboarding/DistSubmitted";

import CreateIndProject from "@/components/ind-onboarding/CreateIndProject";
import SelectIndColors from "@/components/ind-onboarding/SelectIndColors";
import UploadIndImage from "@/components/ind-onboarding/UploadIndImage";
import IndConfirm from "@/components/ind-onboarding/IndConfirm";

import CreateWedProject from "@/components/wed-onboarding/CreateWedProject";
import SelectWedColors from "@/components/wed-onboarding/SelectWedColors";
import UploadWedImage from "@/components/wed-onboarding/UploadWedImage";
import WedConfirm from "@/components/wed-onboarding/WedConfirm";

import NewProject from "@/components/NewProject";
import OrgPatternsAdmin from "@/components/admin/OrgPatternsAdmin";
import OrgPhotoPatternsAdmin from "@/components/admin/OrgPhotoPatternsAdmin";
import ClientView from "@/components/design-portal/ClientView.vue";
import ProjectView from "@/components/design-portal/ProjectView.vue";
import AddNewDesigns from "@/components/design-portal/AddNewDesigns.vue";

import ProjectAdmin from "@/components/admin/ProjectAdmin.vue";
import AdminCreateProject from "@/components/admin/AdminCreateProject.vue";
import AdminPortal from "@/components/admin/AdminPortal.vue";
import AdminColors from "@/components/admin/AdminColors.vue";

import LogIn from "@/components/design-portal/LogIn.vue";
import Colors from "@/components/Colors.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index
    },
    {
      path: "/configurator/:id",
      name: "Configurator",
      component: Configurator,
      props: true
    },
    {
      path: "/pattern-upload",
      name: "Pattern Upload",
      component: PatternUpload
    },
    {
      path: "/new-project",
      name: "NewProject",
      component: NewProject
    },
    {
      path: "/new-project/organizations",
      beforeEnter() {
        window.location.replace(
          "https://www.knottytie.com/pages/org-onboarding"
        );
      }
    },
    {
      path: "/new-project/organizations/styles",
      name: "SelectOrgStyles",
      component: SelectOrgStyles
    },
    {
      path: "/new-project/organizations/upload-logo",
      name: "UploadOrgLogo",
      component: UploadOrgLogo
    },
    {
      path: "/new-project/organizations/select-colors",
      name: "SelectOrgColors",
      component: SelectOrgColors
    },
    {
      path: "/new-project/organizations/confirm",
      name: "OrgConfirm",
      component: OrgConfirm
    },

    {
      path: "/new-project/distributors",
      name: "CreateDistProject",
      component: CreateDistProject
    },
    {
      path: "/new-project/distributors/styles",
      name: "SelectDistStyles",
      component: SelectDistStyles
    },
    {
      path: "/new-project/distributors/upload-logo",
      name: "UploadDistLogo",
      component: UploadDistLogo
    },
    {
      path: "/new-project/distributors/select-colors",
      name: "SelectDistColors",
      component: SelectDistColors
    },
    {
      path: "/new-project/distributors/confirm",
      name: "DistConfirm",
      component: DistConfirm
    },

    {
      path: "/new-project/wed",
      beforeEnter() {
        window.location.replace(
          "https://www.knottytie.com/pages/start-custom-wedding-design"
        );
      }
    },
    {
      path: "/new-project/wed/select-colors",
      name: "SelectWedColors",
      component: SelectWedColors
    },
    {
      path: "/new-project/wed/upload-image",
      name: "UploadWedImage",
      component: UploadWedImage
    },
    {
      path: "/new-project/wed/confirm",
      name: "WedConfirm",
      component: WedConfirm
    },

    {
      path: "/new-project/ind",
      name: "CreateIndProject",
      component: CreateIndProject
    },
    {
      path: "/new-project/ind/select-colors",
      name: "SelectIndColors",
      component: SelectIndColors
    },
    {
      path: "/new-project/ind/upload-image",
      name: "UploadIndImage",
      component: UploadIndImage
    },
    {
      path: "/new-project/ind/confirm",
      name: "IndConfirm",
      component: IndConfirm
    },

    {
      path: "/new-project/organizations/submitted",
      name: "OrgSubmitted",
      component: OrgSubmitted
    },
    {
      path: "/admin/org-patterns",
      name: "OrgPatternsAdmin",
      component: OrgPatternsAdmin
    },
    {
      path: "/admin/org-photo-patterns",
      name: "OrgPhotoPatternsAdmin",
      component: OrgPhotoPatternsAdmin
    },
    {
      path: "/admin/project/:id",
      name: "ProjectAdmin",
      component: ProjectAdmin
    },
    {
      path: "/admin/admin-portal",
      name: "AdminPortal",
      component: AdminPortal
    },
    {
      path: "/admin/colors",
      name: "AdminColors",
      component: AdminColors
    },
    {
      path: "/projects",
      name: "ClientView",
      component: ClientView
    },
    {
      path: "/project/:id/add-patterns",
      name: "AddNewDesigns",
      component: AddNewDesigns
    },
    {
      path: "/project/:id",
      name: "ProjectView",
      component: ProjectView
    },
    {
      path: "/log-in",
      name: "LogIn",
      component: LogIn
    },
    {
      path: "/admin/create-project",
      name: "AdminCreateProject",
      component: AdminCreateProject
    },
    {
      path: "/colors",
      name: "Colors",
      component: Colors
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js